import { OfflineVerificationElgibilityCheckResp } from 'types/api/response/offline-verification-elgibility-check-resp'

import { api } from './api'

export const offlineVerificationEligibilityCheck = (
  itemAttributes: Array<{
    field_name: string
    value: string | number | Array<number> | Record<string, number>
  }>,
) =>
  api.post<OfflineVerificationElgibilityCheckResp>('/offline_verification/eligibility', {
    item_attributes: itemAttributes,
  })
